

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import TruckImage from './Images/TruckImage.png';
// import Logo from './Images/trucklogo.png';
// import ChangePassword from './ChangePassword';
// import './Login.css';

// const ForgotPassword = () => {
//   const [email, setEmail] = useState('');
//   const [step, setStep] = useState(1);
//   const [enteredOtp, setEnteredOtp] = useState('');
//   const [message, setMessage] = useState('');
//   const navigate = useNavigate();
//   const [securityQuestion, setSecurityQuestion] = useState('');
//   const [userAnswer, setUserAnswer] = useState('');
//   const [otpResendTimer, setOtpResendTimer] = useState(60);
//   const [isResendAllowed, setIsResendAllowed] = useState(false);

//   useEffect(() => {
//     let interval;
//     if (!isResendAllowed && step === 3) {
//       interval = setInterval(() => {
//         setOtpResendTimer((prev) => {
//           if (prev === 1) {
//             clearInterval(interval);
//             setIsResendAllowed(true);
//             return 60;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//     }

//     return () => clearInterval(interval);
//   }, [isResendAllowed, step]);

//   const handleVerifyEmail = async () => {
//     try {
//       const res = await fetch('https://salesjet-10097049716.development.catalystappsail.com/forgot-password', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         setMessage('');
//         setSecurityQuestion(data.securityQuestion); // ✅ Get question here
//         setStep(2); // Go to Q&A step
//       } else {
//         setMessage(data.message);
//       }
//     } catch (err) {
//       setMessage('Something went wrong.');
//     }
//   };

//   const handleResendOtp = async () => {
//     try {
//       const res = await fetch('https://salesjet-10097049716.development.catalystappsail.com/verify-answer', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, answer: userAnswer }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         setMessage('OTP resent to your reporting manager.');
//         setIsResendAllowed(false);
//       } else {
//         setMessage(data.message || 'Failed to resend OTP.');
//       }
//     } catch (err) {
//       setMessage('Something went wrong while resending OTP.');
//     }
//   };

//   // ✅ Step 2: Validate Answer, send OTP to Reporting Manager
//   const handleAnswerValidation = async () => {
//     try {
//       const res = await fetch('https://salesjet-10097049716.development.catalystappsail.com/verify-answer', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, answer: userAnswer }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         setMessage('OTP sent to your reporting manager.');
//         setStep(3); // go to OTP step
//       } else {
//         setMessage(data.message || 'Incorrect answer.');
//       }
//     } catch (err) {
//       setMessage('Error verifying answer.');
//     }
//   };

//   // ✅ Step 3: Validate OTP
//   const handleOtpValidation = async () => {
//     try {
//       const res = await fetch('https://salesjet-10097049716.development.catalystappsail.com/verify-otp', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, otp: enteredOtp }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         setMessage('');
//         setStep(4); // go to Change Password
//       } else {
//         setMessage(data.message || 'Invalid OTP');
//       }
//     } catch (err) {
//       setMessage('Error verifying OTP.');
//     }
//   };

//   return (
//     <div className="login-wrapper">
//       <div className="login-image-section">
//         <img src={TruckImage} alt="Truck" className="truck-image" />
//         <img src={Logo} alt="ACVL Logo" className="logo" />
//       </div>
//       <div className="login-form-section">
//         <h1 className="app-name">Sales Jet</h1>
//         <div className="login-box">
//           {step === 1 && (
//             <>
//               <h2 className="login-title">Enter Your Email</h2>
//               <input
//                 type="email"
//                 className="login-input"
//                 placeholder="Enter your registered email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               />
//               <button className="login-button" onClick={handleVerifyEmail}>Verify</button>
//                 <p style={{ fontSize: '12px', color: '#555', marginTop: '10px' }}>
//                   <b>Note:</b>
//                 </p>
//                 <p style={{ fontSize: '12px', color: '#555', marginTop: '3px' }}>
//                   For changing password, first verify your email, then answer the security question,
//                   then complete OTP verification. The OTP will be sent to your Reporting Manager.
//                   After that, you can change the password.
//                 </p>
//             </>
//           )}

//           {step === 2 && (
//             <>
//               <h2 className="login-title">Security Question</h2>
//               <p className="login-question">{securityQuestion}</p>
//               <input
//                 type="text"
//                 className="login-input"
//                 placeholder="Your Answer"
//                 value={userAnswer}
//                 onChange={(e) => setUserAnswer(e.target.value)}
//               />
//               <button className="login-button" onClick={handleAnswerValidation}>Submit Answer</button>
//             </>
//           )}

//           {/* {step === 3 && (
//             <>
//               <h2 className="login-title">Enter OTP</h2>
//               <input
//                 type="text"
//                 className="login-input"
//                 placeholder="Enter OTP"
//                 value={enteredOtp}
//                 onChange={(e) => setEnteredOtp(e.target.value)}
//               />
//               <button className="login-button" onClick={handleOtpValidation}>Validate OTP</button>
//             </>
//           )} */}
//           {step === 3 && (
//             <>
//               <h2 className="login-title">Enter OTP</h2>
//               <div style={{ position: 'relative', width: '100%', marginTop: '20px' }}>
//                 <input
//                   type="text"
//                   className="login-input"
//                   placeholder="Enter OTP"
//                   value={enteredOtp}
//                   onChange={(e) => setEnteredOtp(e.target.value)}
//                 />
//                 <div style={{
//                     position: 'absolute',
//                     right: '10px',
//                     bottom: '-20px',
//                     fontSize: '13px',
//                   }}>
//                   {isResendAllowed ? (
//                     <span
//                       className="resend-link"
//                       style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
//                       onClick={handleResendOtp}
//                     >
//                       Resend OTP
//                     </span>
//                   ) : (
//                     <span style={{ color: 'gray', fontSize: '14px' }}>
//                       Resend in {otpResendTimer}
//                     </span>
//                   )}
//                 </div>
//               </div>
//               <button className="login-button" onClick={handleOtpValidation} style={{ marginTop: '30px' }} >Validate OTP</button>
//             </>
//           )}

//           {step === 4 && <ChangePassword email={email} />}

//           {message && <p className="login-message">{message}</p>}

//           <div className="login-remember">
//             <span
//               className="forgot-link"
//               style={{ cursor: 'pointer', textDecoration: 'underline' }}
//               onClick={() => navigate('/')}
//             >
//               Back to Login
//             </span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TruckImage from './Images/TruckImage.png';
import ChangePassword from './ChangePassword';
import './Login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [step, setStep] = useState(1);
  const [enteredOtp, setEnteredOtp] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [securityQuestion, setSecurityQuestion] = useState('');
  const [userAnswer, setUserAnswer] = useState('');
  const [otpResendTimer, setOtpResendTimer] = useState(60);
  const [isResendAllowed, setIsResendAllowed] = useState(false);

  useEffect(() => {
    let interval;
    if (!isResendAllowed && step === 3) {
      interval = setInterval(() => {
        setOtpResendTimer((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            setIsResendAllowed(true);
            return 60;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isResendAllowed, step]);

  const handleVerifyEmail = async () => {
    try {
      const res = await fetch('https://salesjet-10097049716.development.catalystappsail.com/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage('');
        setSecurityQuestion(data.securityQuestion); // ✅ Get question here
        setStep(2); // Go to Q&A step
      } else {
        setMessage(data.message);
      }
    } catch (err) {
      setMessage('Something went wrong.');
    }
  };

  const handleResendOtp = async () => {
    try {
      const res = await fetch('https://salesjet-10097049716.development.catalystappsail.com/verify-answer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, answer: userAnswer }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage('OTP resent to your reporting manager.');
        setIsResendAllowed(false);
      } else {
        setMessage(data.message || 'Failed to resend OTP.');
      }
    } catch (err) {
      setMessage('Something went wrong while resending OTP.');
    }
  };
  // Step 2: Validate Answer, send OTP to Reporting Manager
  const handleAnswerValidation = async () => {
    try {
      const res = await fetch('https://salesjet-10097049716.development.catalystappsail.com/verify-answer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, answer: userAnswer }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage('OTP sent to your reporting manager.');
        setStep(3); // go to OTP step
      } else {
        setMessage(data.message || 'Incorrect answer.');
      }
    } catch (err) {
      setMessage('Error verifying answer.');
    }
  };
  
  // Step 3: Validate OTP
  const handleOtpValidation = async () => {
    try {
      const res = await fetch('https://salesjet-10097049716.development.catalystappsail.com/verify-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp: enteredOtp }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage('');
        setStep(4); // go to Change Password
      } else {
        setMessage(data.message || 'Invalid OTP');
      }
    } catch (err) {
      setMessage('Error verifying OTP.');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-image-section">
  
        <img 
          src={TruckImage} 
          alt="Truck" 
          className="truck-image"
          loading="eager"
          fetchpriority="high"
          width="600"
          height="400"
        />

        <img src="https://allcanadavanlines.com/static/media/ACVLediteddd.bea95372cf56c281932e.png" alt="ACVL Logo" className="logo" />
      </div>
      <div className="login-form-section">
        <h1 className="app-name">Sales Jet</h1>
        <div className="login-box">
          {step === 1 && (
            <>
              <h2 className="login-title">Enter Your Email</h2>
              <input
                type="email"
                className="login-input"
                placeholder="Enter your registered email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="login-button" onClick={handleVerifyEmail}>Verify</button>
                <p style={{ fontSize: '12px', color: '#555', marginTop: '10px' }}>
                  <b>Note:</b>
                </p>
                <p style={{ fontSize: '12px', color: '#555', marginTop: '3px' }}>
                  For changing password, first verify your email, then answer the security question,
                  then complete OTP verification. The OTP will be sent to your Reporting Manager.
                  After that, you can change the password.
                </p>
            </>
          )}

          {step === 2 && (
            <>
              <h2 className="login-title">Security Question</h2>
              <p className="login-question">{securityQuestion}</p>
              <input
                type="text"
                className="login-input"
                placeholder="Your Answer"
                value={userAnswer}
                onChange={(e) => setUserAnswer(e.target.value)}
              />
              <button className="login-button" onClick={handleAnswerValidation}>Submit Answer</button>
            </>
          )}
          {step === 3 && (
            <>
              <h2 className="login-title">Enter OTP</h2>
              <div style={{ position: 'relative', width: '100%', marginTop: '20px' }}>
                <input
                  type="text"
                  className="login-input"
                  placeholder="Enter OTP"
                  value={enteredOtp}
                  style={{ width: '100%'}}
                  onChange={(e) => setEnteredOtp(e.target.value)}
                />
                <div style={{
                    position: 'absolute',
                    right: '10px',
                    bottom: '-20px',
                    fontSize: '13px',
                  }}>
                  {isResendAllowed ? (
                    <span
                      className="resend-link"
                      style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                      onClick={handleResendOtp}
                    >
                      Resend OTP
                    </span>
                  ) : (
                    <span style={{ color: 'gray', fontSize: '14px' }}>
                      Resend in {otpResendTimer}
                    </span>
                  )}
                </div>
              </div>
              <button className="login-button" onClick={handleOtpValidation} style={{ marginTop: '30px' }} >Validate OTP</button>
            </>
          )}

          {step === 4 && <ChangePassword email={email} />}

          {message && <p className="login-message">{message}</p>}

          <div className="login-remember">
            <span
              className="forgot-link"
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={() => navigate('/')}
            >
              Back to Login
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;